import React from 'react'
import Main from './Main'
import Sections from './Sections'
import Counter from './Counter'
import CardSwiper from './CardSwiper'
import PlateFrom from './PlateFrom'
import Testimonials from './Testimonials'
import Purpose from './Purpose'
import RequestDemo from './RequestDemo'




const Home = () => {
  return (
    <>
      <section className='home-main-contect'>
        {/* <Herosection/> */}
        <div className='line-img-home'>

          <svg height="4574" viewBox="0 0 891 4474" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.11" d="M666.997 1.1936C749.997 391.194 706.999 727.694 494.999 1029.19C282.998 1330.69 -114.002 1679.69 34.9994 2304.2" stroke="#232728" strokeWidth="3" strokeDasharray="7 7" />
            <path opacity="0.11" d="M35 2304.2C118 2649.7 677.5 2687 677.5 2687C677.5 2687 888.5 2823 888.5 3114" stroke="#232728" strokeWidth="3" strokeDasharray="7 7" />
            <path opacity="0.11" d="M889 3104C889 3755.76 673 4100.79 673 4474" stroke="#232728" strokeWidth="3" strokeDasharray="7 7" />
          </svg>
        </div>
        <Main />
        <Sections />
        <Counter />
        <CardSwiper />
        <PlateFrom />
        <Testimonials />
        <Purpose />
        <RequestDemo />

      </section>

      {/* <Oxygenbenefits/> */}

    </>
  )
}

export default Home